<header class="shadow-md sticky top-0 bg-white z-30">
  <div class="sticky py-1 mx-5 flex justify-between items-center">
    <button (click)="toggleSidebar()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 ">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
      </svg>
    </button>
    <div class="flex  flex-col justify-center ml-10 items-center ">
      <img class="w-26 h-20 cursor-pointer" routerLink="dashboard"
        src="https://images.mashhoorplus.in/file/mashhoor-plus.png" alt="">
      <div class="menu text-black ">
        <ul class="md:flex hidden flex-row gap-5">
          <li class="">
            <a routerLink="/" routerLinkActive="active font-bold">Home</a>
          </li>
          <li class=" dropdown">
            <a routerLink="/products" routerLinkActive="active font-bold">Products</a>
            <!-- <div class="relative inline-block shadow-md">
              <div class="absolute left-0 w-screen bg-white shadow-md mt-5 hidden min-w-[160px] z-10 dropdown-content">
                <a class="block text-black text-opacity-50 text-xs no-underline px-4 py-2" *ngFor="let data of products" href="#">{{data.title}}</a>
              </div>
            </div> -->
          </li>
          <li class=" ">
            <a routerLink="/blogs" routerLinkActive="active font-bold">Blogs</a>
          </li>
          <li class=" ">
            <a routerLink="/about-us" routerLinkActive="active font-bold">About</a>
          </li>
          <li class="">
            <a routerLink="/contact-us" routerLinkActive="active font-bold">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>
    <nav class="flex flex-row md:gap-10 gap-5 text-2xl cursor-pointer ">
      <div class="relative justify-center flex flex-col">
        <button (click)="openSearch()" class="focus:outline-none">
          <i class="pi pi-search text-xl text-black"></i>
        </button>
        <!-- <div *ngIf="isSearchOpen"
          class=" w-64 w-64 opacity-100 md:w-80 bg-white shadow-lg rounded-full overflow-hidden transition-all duration-300"
          [ngClass]="{'w-0 opacity-0': !isSearchOpen, 'w-64 opacity-100': isSearchOpen}">
          <input type="text" placeholder="Search products..."
            class="w-full p-2 pl-8 pr-3 text-black outline-none rounded-full">
        </div> -->
      </div>
      <div class="flex items-center justify-center ">
        <img routerLink="/track" class="track-icon hover:scale-105" src="https://img.icons8.com/ios/50/in-transit--v1.png" alt="in-transit--v1" />
      </div>
      <div class="relative text-center" (click)="openCart()">

        <p-avatar icon="pi pi-cart-plus" pBadge styleClass="mr-2" severity="danger" value="4"
          [styleClass]="'bg-secondary'" shape="circle" />
        <!-- <i class="pi pi-cart-plus text-2xl text-black"></i> -->

        <!-- <p class="text-xs font-bold">Cart</p> -->
        <span class="absolute top-0 right-0 inline-block text-white  
        text-xs mr-0 rounded-full font-semi-bold px-0.5 bg-red-500" style="font-size: 15px;">{{cartItemCount}}</span>
      </div>
    </nav>
  </div>
  <hr class="h-1">
  <div class="md:hidden lg:hidden flex flex-row relative min-w-full px-1 z-100 bg-white shadow-lg sticky top-20">
    <!-- Left Scroll Button -->
    <button class=" p-2 rounded-full" (click)="scrollLeft()">
      ❮
    </button>

    <div #scrollContainer
      class="flex w-full md:justify-evenly lg:justify-evenly justify-start my-2 overflow-auto whitespace-nowrap gap-5 scrollbar-hide">
      <div class="relative cursor-pointer flex flex-col justify-center items-center" *ngFor="let data of category"
        (click)="redirectToProduct(data.id)">
        <div class="icon-container shadow-lg">
          <img class="icon-image bg-secondary p-2" [src]="data.img" alt="{{data.name}}">
        </div>
        <p class="text-black hover:shadow-lg font-bold z-10 antialiased my-1 ">
          {{data.name}}
        </p>
      </div>
    </div>

    <!-- Right Scroll Button -->
    <button class="p-2 rounded-full" (click)="scrollRight()">
      ❯
    </button>
  </div>
</header>